import { ClientsService } from '../services'

const getRulesDetail = (id) => {
    return new Promise(async (resolve, reject) => {
        await ClientsService.getRulesDetail(id)
        .then(response => resolve(response.data))
        .catch(err => reject({ error: true }))
    })
}
export default getRulesDetail;